import { setSummaryButtonAtom as m, allocateGuestsAtom as s } from "./index34.mjs";
import { setCurrentStepAtom as u } from "./index25.mjs";
import { useSetAtom as t } from "jotai";
const p = () => {
  const o = t(m), e = t(u), r = t(s);
  return {
    setSummaryButton: o,
    setCurrentStep: e,
    allocateGuests: r
  };
};
export {
  p as useCheckout
};
